import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import Entity from "../datasource/Entity";
import clientConfig from "../config/client";
import { Box } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import VectorPrices from "../components/VectorPrices/VectorPrices.jsx";

class VectorPricesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("vector_prices");
        this.getAuxData();
        this.state = { ...this.state, loadAfterChangedByRule: false };
    }

    render = () => {
        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        const rates =
            this.props.auxData &&
            this.props.auxData.rates_short?.filter((r) => r.active);
        const roomTypes =
            this.props.auxData &&
            this.props.auxData.room_types?.filter((r) => r.active);

        const fields = [
            { id: 0, name: "Квота" },
            { id: 1, name: "1ВЗ" },
            { id: 2, name: "2ВЗ" },
            { id: 3, name: "3ВЗ" },
            { id: 4, name: "4ВЗ" },
            { id: 5, name: "5ВЗ" },
            { id: 6, name: "6ВЗ" },
            { id: 7, name: "7ВЗ" },
            { id: 8, name: "8ВЗ" },
            { id: 9, name: "9ВЗ" },
            { id: 10, name: "10ВЗ" },
            { id: 11, name: "11ВЗ" },
            { id: 12, name: "12ВЗ" },
            { id: 13, name: "Ребенок" },
            { id: 14, name: "Младенец без места" },
            { id: 15, name: "Колыбель" },
            { id: 16, name: "Взрослый на доп. месте" },
            { id: 17, name: "Ребенок на доп. месте" },
        ];

        let vectorPrices = (
            <Box mt={4}>
                <LinearProgress mt={3} />
            </Box>
        );

        if (roomTypes && rates) {
            vectorPrices = (
                <VectorPrices
                    roomTypes={roomTypes}
                    rates={rates}
                    fields={fields}
                    hotelId={this.props.match.params.mainId}
                    initAction={this.getAllItems}
                    prices={this.state.AllItems}
                />
            );
        }

        return (
            <Paper elevation={3}>
                <Box p={3}>
                    <Typography mb={3} variant={"h5"}>
                        Векторные цены и квоты
                    </Typography>
                </Box>
                {vectorPrices}
            </Paper>
        );
    };
}

export default VectorPricesContainer;
